export const APP_CONFIG = {
  appName: 'Terminal Observability',
  version: '1.0.0',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8000',
  wsUrl: import.meta.env.VITE_WS_URL || 'ws://127.0.0.1:8000/ws/events',
  enableMockFallback: import.meta.env.VITE_ENABLE_MOCK_FALLBACK !== 'false',
  pollIntervals: {
    liveWs: 30000,     // Slower background sync when WS is healthy (30s)
    fallback: 5000,    // Active polling interval when WS is disconnected (5s)
    marketStatus: 15000,
  },
  wsReconnect: {
    delays: [1000, 2000, 4000, 8000, 10000],
    maxDelay: 10000,
  },
};

export const ROUTES = {
  OVERVIEW: 'overview',
  POSITIONS: 'positions',
  TRADES: 'trades',
  ORDERS: 'orders',
  HISTORY: 'history',
  SIGNALS: 'signals',
  RISK_HEALTH: 'risk-health',
  ANALYTICS: 'analytics',
  THEMES: 'themes',
  SETTINGS: 'settings',
} as const;

export type NavigationTab = typeof ROUTES[keyof typeof ROUTES];
